import type { ReactNode } from 'react';
import { cn } from '#client/lib/cn';

interface CardProps {
  title?: ReactNode | undefined;
  subtitle?: ReactNode | undefined;
  actions?: ReactNode | undefined;
  footer?: ReactNode | undefined;
  /** Removes the inner padding, for cards that wrap a full-bleed table. */
  flush?: boolean | undefined;
  children: ReactNode;
  className?: string | undefined;
}

/** Titled surface for one block of related content. */
export function Card({
  title,
  subtitle,
  actions,
  footer,
  flush = false,
  children,
  className,
}: CardProps) {
  return (
    <section className={cn('c-card', className)}>
      {(title || actions) && (
        <header className="c-card__header">
          {title && (
            <div>
              <h2 className="c-card__title">{title}</h2>
              {subtitle && <p className="c-card__subtitle">{subtitle}</p>}
            </div>
          )}
          {actions && <div className="c-card__actions">{actions}</div>}
        </header>
      )}
      <div className={cn('c-card__body', flush && 'c-card__body--flush')}>{children}</div>
      {footer && <footer className="c-card__footer">{footer}</footer>}
    </section>
  );
}
